import React, { useEffect, useRef } from "react";
import { MdClose } from "@react-icons/all-files/md/MdClose";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: JSX.Element;
};

export const BaseModal = ({ isOpen, onClose, children }: Props) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      // Adiciona a classe opacity-100 para tornar o modal visível
      modalRef.current.classList.add("translate-y-0");
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-end justify-center">
          <div
            className="bg-black opacity-50 w-full h-full fixed"
            onClick={onClose}
          ></div>
          <div
            ref={modalRef}
            className="bg-white p-4 rounded-t-md relative z-10 w-full max-w-screen-md"
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <MdClose />
            </button>
            {children}
          </div>
        </div>
      )}
    </>
  );
};
